import { Observable } from "rxjs";
import { Subject, Subscription } from "rxjs";
import { Component, OnInit } from "@angular/core";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { Router, ActivatedRoute, Params } from '@angular/router';

import swal from "bootstrap-sweetalert";

import { ProfileService } from "app/services/profile.service";

@Component({
  templateUrl: "restore.component.html",
  styleUrls: ["restore.component.scss"]
})
export class RestoreComponent {

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _profileService: ProfileService,
    private _router: Router) { }

  private _restoreSubscription: Subscription = null;

  restoreAccount() {
    this._restoreSubscription = this._profileService.restoreUser(this.username)
      .subscribe(email => {
        swal('Ок', 'Мы отправили ссылку для восстановления доступа на ваш адрес электронной почты: ' + email, 'success');
        this._router.navigate(['/call/list']);
      },
        error => {
          if (error.status == 404) {
            this._accountRestoreError = "Пользователь с указанным именем не найден.";
          } else if (error.status == 409) {
            this._accountRestoreError = "Данный аккаунт не активирован в системе.";
          } else {
            this._accountRestoreError = 'При восстановлении пароля произошла ошибка. Повторите попытку позже.';
          }
      },
      () => {
        this.username = null;
      });
  }

  private _accountRestoreError: string = null;

  username: string;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/account/restore/restore.component.ts